import {useMutation, useQueryClient} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';

export interface PoleActionVoteMutationRequest {
  id: number;
  answerId: number;
  count: number;
}
export interface PoleActionVoteMutationResponse {
  success?: boolean;
  rewards?: {
    poe?: number;
    coins?: number;
  };
}

export const usePoleActionVoteMutation = () => {
  const queryCLient = useQueryClient();

  return useMutation<PoleActionVoteMutationResponse, unknown, PoleActionVoteMutationRequest>({
    mutationFn: async ({id, ...body}) => {
      const response = await api.post<PoleActionVoteMutationResponse>(`/polls/vote/${id}`, body);
      return response.data;
    },
    onSuccess(_, {id}) {
      queryCLient.invalidateQueries({queryKey: ['action-by-id', id]});
    },
  });
};
